import React, { useState } from 'react'
import { useDispatch } from 'react-redux';

import { setCurrentTableCellAC } from 'store/actions/table';

import EditableCellByType from './EditableCellByType';

const EditableCellContainer = (props) => {
  const [isEditable, setIsEditable] = useState(false)

  const dispatch = useDispatch()

  const handleSetValue = ({ value, cell, row }) => {
    const columnId = cell.column.id;
    const rowIndex = row.index;
    const newValue = value;

    dispatch(setCurrentTableCellAC(columnId, props?.tableData[rowIndex]?.lineElements, newValue));
    setIsEditable(false);
  };

  return <EditableCellByType {...props} isEditable={isEditable} setCellValue={handleSetValue} setIsEditable={setIsEditable}/>
};

export default EditableCellContainer 